/* Sheen product page — interactions + cart. Ported from design handoff, framework-free. */
(function () {
  'use strict';

  function enforceVideoAttrs(root) {
    root.querySelectorAll('#surface-video, #steps-scroller video').forEach(function (v) {
      v.muted = true; v.loop = true; v.setAttribute('muted', ''); v.setAttribute('loop', '');
    });
    
  }

  /* ---------------- gallery + lightbox ---------------- */
  function initGallery(root) {
    var main = root.querySelector('#hero-main');
    var thumbs = root.querySelectorAll('.hero-thumb');
    var lightbox = root.querySelector('#gallery-lightbox');
    var grid = root.querySelector('#lightbox-grid');
    var closeBtn = root.querySelector('#lightbox-close');
    var countEl = root.querySelector('#lightbox-count');
    var moreEl = root.querySelector('#thumb-more-count');
    var PH = main ? main.getAttribute('src') : '';
    var GALLERY = ["https://cdn.shopify.com/s/files/1/1046/6725/1028/files/Main_Side.png?v=1782692178&width=1000","https://cdn.shopify.com/s/files/1/1046/6725/1028/files/Main_Grip.png?v=1782692178&width=1000","https://cdn.shopify.com/s/files/1/1046/6725/1028/files/Main_Steam_Nozzle.png?v=1782692178&width=1000","https://cdn.shopify.com/s/files/1/1046/6725/1028/files/Main_Composition-2.png?v=1782847548&width=1000","https://cdn.shopify.com/s/files/1/1046/6725/1028/files/Use_Case_Brush.png?v=1782692270&width=1000","https://cdn.shopify.com/s/files/1/1046/6725/1028/files/Use_Case_Gap_Nozzle.png?v=1782692270&width=1000","https://cdn.shopify.com/s/files/1/1046/6725/1028/files/Use_case_long_cone_nozzle.png?v=1782692271&width=1000","https://cdn.shopify.com/s/files/1/1046/6725/1028/files/Use_Case_Glass_Squeege.png?v=1782837372&width=1000"];
    var openLb = function () { if (lightbox) lightbox.style.display = 'flex'; };
    var closeLb = function () { if (lightbox) lightbox.style.display = 'none'; };
    if (grid) {
      grid.innerHTML = '';
      GALLERY.forEach(function (src) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'aspect-square bg-cream-200 rounded-xl overflow-hidden';
        var im = document.createElement('img');
        im.className = 'w-full h-full object-cover'; im.alt = 'Sheen Steamer photo'; im.loading = 'lazy'; im.src = src;
        b.appendChild(im);
        b.addEventListener('click', function () { if (main) main.src = src; closeLb(); });
        grid.appendChild(b);
      });
    }
    if (countEl) countEl.textContent = GALLERY.length;
    if (moreEl) moreEl.textContent = '+' + Math.max(0, GALLERY.length - 4) + ' more';
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.galleryMore) { openLb(); return; }
        if (main && btn.dataset.src) main.src = btn.dataset.src;
      });
    });
    if (main) { main.style.cursor = 'zoom-in'; main.addEventListener('click', openLb); }
    if (closeBtn) closeBtn.addEventListener('click', closeLb);
    if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLb(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });

    var mGal = root.querySelector('#m-gallery');
    var mDots = root.querySelector('#m-gallery-dots');
    if (mGal) {
      mGal.innerHTML = '';
      GALLERY.forEach(function (src) {
        var im = document.createElement('img');
        im.className = 'w-full h-full flex-shrink-0 snap-center object-cover'; im.alt = 'Sheen Steamer photo'; im.loading = 'lazy'; im.src = src;
        mGal.appendChild(im);
      });
      if (mDots) {
        mDots.innerHTML = '';
        GALLERY.forEach(function () {
          var d = document.createElement('span');
          d.style.cssText = 'width:7px;height:7px;border-radius:9999px;display:inline-block;background:#DBE7EC;transition:all .25s;';
          mDots.appendChild(d);
        });
        var syncM = function () {
          var w = mGal.clientWidth || 1;
          var act = Math.max(0, Math.min(GALLERY.length - 1, Math.round(mGal.scrollLeft / w)));
          Array.prototype.forEach.call(mDots.children, function (d, i) {
            var on = i === act; d.style.width = on ? '18px' : '7px'; d.style.background = on ? '#2E97B0' : '#DBE7EC';
          });
        };
        var rg = null;
        mGal.addEventListener('scroll', function () { if (rg) cancelAnimationFrame(rg); rg = requestAnimationFrame(syncM); }, { passive: true });
        syncM();
      }
    }
  }

  /* ---------------- surface selector ---------------- */
  function initSurface(root) {
    var VIDS = {
      grout: { label: 'Grout &amp; tile', src: 'https://cdn.shopify.com/videos/c/vp/bb423e1964dd4f1f9d97cfbe1845677d/bb423e1964dd4f1f9d97cfbe1845677d.SD-480p-1.5Mbps-87614772.mp4' },
      bathroom: { label: 'Bathroom', src: 'https://cdn.shopify.com/videos/c/vp/38c59d49ad6b4d9199f25c03c483eba1/38c59d49ad6b4d9199f25c03c483eba1.SD-480p-1.5Mbps-87614770.mp4' },
      kitchen: { label: 'Kitchen &amp; oven', src: 'https://cdn.shopify.com/videos/c/vp/2c3a94acad5c470b9682b6bb76cda13d/2c3a94acad5c470b9682b6bb76cda13d.SD-480p-1.5Mbps-87614773.mp4' },
      glass: { label: 'Glass &amp; mirrors', src: 'https://cdn.shopify.com/videos/c/vp/fa0abff020b74edb8885fbc1196e9737/fa0abff020b74edb8885fbc1196e9737.SD-480p-1.5Mbps-87614771.mp4' }
    };
    var chips = root.querySelectorAll('.surface-chip');
    var video = root.querySelector('#surface-video');
    var badge = root.querySelector('#surface-badge');
    if (!chips.length || !video) return;
    var setActive = function (key) {
      var d = VIDS[key];
      if (!d) return;
      if (badge) badge.innerHTML = d.label;
      video.setAttribute('data-video', key);
      if (d.src) {
        if (video.getAttribute('src') !== d.src) {
          video.setAttribute('src', d.src); video.load();
          var p = video.play(); if (p && p.catch) p.catch(function () {});
        }
      }
      chips.forEach(function (c) {
        var on = c.dataset.key === key;
        c.style.background = on ? '#16191D' : '#DBE7EC';
        c.style.color = on ? '#ECF4F7' : '#5A6470';
        c.style.borderColor = on ? '#16191D' : '#DBE7EC';
      });
    };
    chips.forEach(function (c) { c.addEventListener('click', function () { setActive(c.dataset.key); }); });
    var __svStarted=false;
    if('IntersectionObserver' in window){
      var __svio=new IntersectionObserver(function(es){es.forEach(function(e){
        if(e.isIntersecting){ if(!__svStarted){__svStarted=true;setActive('kitchen');} else {var pq=video.play();if(pq&&pq.catch)pq.catch(function(){});} }
        else { if(video&&!video.paused)video.pause(); }
      });},{threshold:0.25});
      __svio.observe(video);
    } else { setActive('kitchen'); }
  }

  /* ---------------- quantity stepper ---------------- */
  function initQty(root) {
    var minus = root.querySelector('#qty-minus');
    var plus = root.querySelector('#qty-plus');
    var val = root.querySelector('#qty-val');
    var ctaPrice = root.querySelector('#hero-cta-price');
    var q = 1; var UNIT = 45;
    var render = function () { if (val) val.textContent = q; if (ctaPrice) ctaPrice.textContent = '£' + (q * UNIT); };
    if (minus) minus.addEventListener('click', function () { q = Math.max(1, q - 1); render(); });
    if (plus) plus.addEventListener('click', function () { q = Math.min(9, q + 1); render(); });
    render();
  }

  /* ---------------- sticky bar ---------------- */
  function initSticky(root) {
    var bar = root.querySelector('#sticky-bar');
    var hero = root.querySelector('#hero-cta');
    if (!bar || !hero) return;
    var ctaEls = ['#m-offer-cta-block', '#offer-cta'].map(function (s) { return root.querySelector(s); }).filter(Boolean);
    var inView = function (el) {
      if (!el || el.offsetParent === null) return false;
      var r = el.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    };
    var onScroll = function () {
      var heroPast = hero.getBoundingClientRect().bottom < 0;
      var ctaInView = ctaEls.some(inView);
      bar.classList.toggle('translate-y-full', !(heroPast && !ctaInView));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- FAQ accordion (mobile-exclusive) ---------------- */
  function initAccordion(root) {
    /* Buy-box dropdowns kept independent - opening one no longer auto-closes the others. */
  }

  /* ---------------- generic peek carousel ---------------- */
  function makeCarousel(scroller, opts) {
    opts = opts || {};
    var cards = Array.prototype.filter.call(scroller.children, function (el) { return el.nodeType === 1; });
    if (!cards.length) return null;
    var snap = opts.snap || 'start';
    var dots = opts.dots || null;
    var isScrollable = function () { return scroller.scrollWidth > scroller.clientWidth + 4; };
    var activeIndex = function () {
      var sr = scroller.getBoundingClientRect(); var mid = sr.left + sr.width / 2; var best = 0, bd = Infinity;
      cards.forEach(function (c, i) { var r = c.getBoundingClientRect(); var cm = r.left + r.width / 2; var d = Math.abs(cm - mid); if (d < bd) { bd = d; best = i; } });
      return best;
    };
    var scrollToCard = function (c) {
      var r = c.getBoundingClientRect(); var sr = scroller.getBoundingClientRect();
      var delta = (snap === 'center') ? (r.left + r.width / 2) - (sr.left + sr.width / 2) : (r.left - sr.left);
      scroller.scrollBy({ left: delta, behavior: 'smooth' });
    };
    var dotEls = [];
    if (dots) {
      dots.innerHTML = '';
      cards.forEach(function (_, i) {
        var d = document.createElement('span');
        d.style.cssText = 'width:8px;height:8px;border-radius:9999px;cursor:pointer;display:inline-block;background:#C2CDD3;transition:all .25s;';
        d.addEventListener('click', function () { scrollToCard(cards[i]); });
        dots.appendChild(d); dotEls.push(d);
      });
    }
    var sync = function () {
      if (!dotEls.length) return;
      var a = activeIndex();
      dotEls.forEach(function (d, i) { var on = i === a; d.style.width = on ? '26px' : '8px'; d.style.background = on ? '#2E97B0' : '#C2CDD3'; });
    };
    cards.forEach(function (c, i) {
      c.addEventListener('click', function (e) {
        if (isScrollable() && i !== activeIndex()) { e.preventDefault(); e.stopPropagation(); scrollToCard(c); return; }
        if (opts.onActivate) opts.onActivate(c, i, e);
      }, true);
    });
    var raf = null;
    scroller.addEventListener('scroll', function () { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    requestAnimationFrame(sync);
    return { scrollToCard: scrollToCard, activeIndex: activeIndex, isScrollable: isScrollable, sync: sync, cards: cards };
  }

  function initUGC(root) {
    var scroller = root.querySelector('#ugc-scroller');
    if (!scroller) return;
    scroller.querySelectorAll('[data-ugc-card] video').forEach(function (v) {
      var card = v.closest('[data-ugc-card]');
      var overlay = card ? card.querySelector('[data-ugc-overlay]') : null;
      var showOverlay = function () { if (overlay) overlay.style.opacity = '1'; };
      v.addEventListener('ended', showOverlay); v.addEventListener('pause', showOverlay);
      v.addEventListener('loadedmetadata', function () { try { v.currentTime = 0.1; } catch (e) {} });
    });
        var play = function (card) {
      var v = card.querySelector('video'); var overlay = card.querySelector('[data-ugc-overlay]');
      if (!v) return;
      var hasSrc = v.currentSrc || v.querySelector('source');
      if (!hasSrc) return;
      if (!v.paused) { v.pause(); return; }
      scroller.querySelectorAll('[data-ugc-card] video').forEach(function (o) {
        if (o === v) return;
        if (!o.paused) o.pause();
        o.classList.add('ugc-blur');
      });
      if (overlay) overlay.style.opacity = '0';
      v.classList.remove('ugc-blur');
      v.muted = false;
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    };
    makeCarousel(scroller, { snap: 'start', onActivate: play });
    var __ugcPT=null;
    scroller.addEventListener('scroll',function(){if(__ugcPT)clearTimeout(__ugcPT);__ugcPT=setTimeout(function(){scroller.querySelectorAll('[data-ugc-card] video').forEach(function(v){if(!v.paused)v.pause();v.classList.add('ugc-blur');});},60);},{passive:true});
  }

  function initNoSprays(root) {
    var scroller = root.querySelector('#steps-scroller');
    if (!scroller) return;
    makeCarousel(scroller, { snap: 'center', dots: root.querySelector('#steps-dots') });
    var __sv=scroller.querySelectorAll('video');
    if('IntersectionObserver' in window){var __io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){var q=v.play();if(q&&q.catch)q.catch(function(){});}else if(!v.paused){v.pause();}});},{threshold:0.2});__sv.forEach(function(v){__io.observe(v);});}else{__sv.forEach(function(v){var q=v.play();if(q&&q.catch)q.catch(function(){});});}
  }

  function initStraight(root) {
    var scroller = root.querySelector('#straight-scroller');
    if (!scroller) return;
    makeCarousel(scroller, { snap: 'start', dots: root.querySelector('#straight-dots') });
  }

  function initReviews(root) {
    var scroller = root.querySelector('#rev-scroller');
    var track = root.querySelector('#rev-track');
    var prev = root.querySelector('#rev-prev');
    var next = root.querySelector('#rev-next');
    var dotsWrap = root.querySelector('#rev-dots');
    if (!scroller || !track) return;
    track.addEventListener('click', function (e) {
      var card = e.target.closest('[data-rev-card]');
      if (!card || !scroller.contains(card)) return;
      var cr = card.getBoundingClientRect(); var sr = scroller.getBoundingClientRect(); var delta = cr.left - sr.left;
      if (Math.abs(delta) > 12) scroller.scrollBy({ left: delta, behavior: 'smooth' });
    });
    var reals = Array.prototype.slice.call(track.children);
    var total = reals.length;
    if (!total) return;
    var looped = false;
    var cardW = function () { return reals[0] ? reals[0].getBoundingClientRect().width : scroller.clientWidth; };
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < total; i++) {
        (function (i) {
          var d = document.createElement('span');
          d.style.cssText = 'width:8px;height:8px;border-radius:9999px;cursor:pointer;display:inline-block;background:#C2CDD3;transition:all .25s;';
          d.addEventListener('click', function () { scroller.scrollTo({ left: (looped ? i + 1 : i) * cardW(), behavior: 'smooth' }); });
          dotsWrap.appendChild(d);
        })(i);
      }
    }
    var enableLoop = function () {
      if (looped) return;
      if (!window.matchMedia('(max-width: 767px)').matches) return;
      track.insertBefore(reals[total - 1].cloneNode(true), reals[0]);
      track.appendChild(reals[0].cloneNode(true));
      looped = true; scroller.scrollLeft = cardW();
    };
    var realActive = function () {
      var w = cardW(); if (!w) return 0;
      var raw = Math.round(scroller.scrollLeft / w);
      if (looped) { raw = raw - 1; if (raw < 0) raw = total - 1; if (raw > total - 1) raw = 0; }
      return Math.max(0, Math.min(total - 1, raw));
    };
    var sync = function () {
      if (!dotsWrap) return;
      var act = realActive();
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) { var on = i === act; d.style.width = on ? '26px' : '8px'; d.style.background = on ? '#5BBCD0' : '#C2CDD3'; });
    };
    var handleLoop = function () {
      if (!looped) return; var w = cardW(); if (!w) return;
      var idx = Math.round(scroller.scrollLeft / w);
      if (idx <= 0) { scroller.scrollLeft = total * w; } else if (idx >= total + 1) { scroller.scrollLeft = w; }
    };
    var raf = null, to = null;
    scroller.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(sync);
      if (to) clearTimeout(to); to = setTimeout(handleLoop, 90);
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -cardW(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: cardW(), behavior: 'smooth' }); });
    window.addEventListener('resize', function () { enableLoop(); sync(); }, { passive: true });
    requestAnimationFrame(function () { enableLoop(); sync(); });
  }

  /* ---------------- cart (v1: AJAX add -> cart page; drawer upgrade pending) ---------------- */
  function initCart(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sheen-add]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-sheen-add');
      if (!id) return;
      var qty = 1;
      if (btn.hasAttribute('data-sheen-qty')) {
        var v = root.querySelector('#qty-val');
        qty = v ? (parseInt(v.textContent, 10) || 1) : 1;
      }
      if (btn.dataset.busy) return;
      btn.dataset.busy = '1'; btn.style.opacity = '0.7';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { window.location.href = '/cart'; });
    });
  }

  function init() {
    var root = document;
    enforceVideoAttrs(root);
    initGallery(root);
    initSurface(root);
    initUGC(root);
    initNoSprays(root);
    initStraight(root);
    initQty(root);
    initSticky(root);
    initReviews(root);
    initAccordion(root);
    initCart(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
